import {
  matchAppliedStylesWithBrandStyleOnRelation,
} from 'modules/Lexical/TextRelationStyles/matchAppliedStylesWithBrandStyleOnRelation';
import * as Models from 'models';
import { matchAppliedStylesWithBrandStyleOnComponent } from './matchAppliedStylesWithBrandStyleOnComponent';

export const matchAppliedStylesWithBrandStyle = (
  textRelationStyles: Models.TextRelationStyles,
  textComponent: Models.TextComponent,
  brandStyle: Models.BrandStyleMap,
  colors: Models.BrandColorsList,
  fonts: Models.BrandFontsList,
): [Models.TextRelationStyles, Models.TextComponent] => {
  const [updatedTextRelationStyles, brandStyleChangedRelation] = matchAppliedStylesWithBrandStyleOnRelation(
    textRelationStyles, brandStyle, colors, fonts,
  );

  const [updatedTextComponent, brandStyleChangedComponent] = matchAppliedStylesWithBrandStyleOnComponent(
    textComponent, brandStyle, colors, fonts,
  );

  return [
    {
      ...updatedTextRelationStyles,
      brandStyleChanged: brandStyleChangedRelation && brandStyleChangedComponent,
      brandStyleId: brandStyle.get('id'),
    },
    updatedTextComponent,
  ];
};

